// This is generated.  Alter it in blockGroups/formElements/types/NestedObject.js
/* eslint-disable no-unused-vars */
const { Type } = require('@sinclair/typebox');
const { merge } = require('lodash');
const { moduleRegistration } = require('@sstdev/lib_metadata-config');
module.exports = {
  asDataDictionary: function asDataDictionary(hNode, context) {
    const { id, title, propertyName } = hNode;
    //This block tells us nothing about namespaces/relations, but maybe the children do?
    let [subDataDictionary = {}, _partialTypeDefinition = {}] =
      hNode.children?.reduce(
        ([sdd, ptd], child) => {
          const [_subDataDictionary = {}, _partialTypeDefinition = {}] =
            context.extractFromChild(child, context);
          return [
            merge(sdd, _subDataDictionary),
            moduleRegistration.mergePartialTypeDefinitions(
              ptd,
              _partialTypeDefinition,
            ),
          ];
        },
        [{}, {}],
      ) ?? [{}, {}];

    // NestedObject doesn't have a required parameter, so pass undefined to get default behavior
    const { isRequired, isEditable, isOptional } =
      moduleRegistration.resolveFieldFlags(undefined, context);

    const isArray = (hNode.children || []).some(
      (c) => c.hNodeTypeGroup === 'filter',
    );

    const propertySchema = isArray
      ? Type.Array(
          Type.Object(_partialTypeDefinition, {
            title: 'Item',
            'x-dataType': 'object',
            additionalProperties: true,
          }),
          {
            'x-id': id,
            'x-dataType': 'array',
            'x-propertyName': propertyName,
            title: title,
            'x-required': isRequired,
            'x-optional': isOptional,
            'x-editable': isEditable,
          },
        )
      : Type.Object(_partialTypeDefinition, {
          'x-id': id,
          'x-dataType': 'object',
          'x-propertyName': propertyName,
          title: title,
          'x-required': isRequired,
          'x-optional': isOptional,
          'x-editable': isEditable,
          additionalProperties: true,
        });

    const wrappedSchema = isOptional
      ? Type.Optional(propertySchema)
      : propertySchema;

    const partialTypeDefinition = {
      [propertyName]: wrappedSchema,
    };

    return [subDataDictionary, partialTypeDefinition];
  },
};
moduleRegistration.registerHNodeType(
  'formElements',
  'NestedObject',
  module.exports,
);
